import * as React from 'react';
import { withRouter } from 'react-router';
import { Row, Col, Table, Button, Icon, Modal } from 'antd';
import { FormComponentProps } from 'antd/lib/form';
import Loader from 'src/components/common/Loader';
import injectSheet from 'react-jss';
import { Document , CardData } from './Interfaces/Shipment.interface';
import { tokens } from 'src/design-system';
import { commonStyles } from 'src/Library/CommonStyles';
import moment from 'moment';
import { StylesProps , RouterProps } from 'src/Library/Types';
import { updateDocuments } from 'src/api/shipmentTracking';
import { useGenericState } from 'src/Library/UseGenericState';
import { ColumnProps } from 'antd/lib/table';
import uuid from 'uuid';
import DocumentUploadModal from './DocumentUploadModal';
const styles = theme => ({
  ...commonStyles(theme),
    docStyle: {
      fontWeight: tokens.fontWeight.semibold,
      fontSize: tokens.fontSize.h3,
      lineHeight: '18px',
  },
    imgDiv : {
      borderRight: `1px solid ${tokens.colors.border}`,
      margin: '3% 0 10% 0',
      display: 'flex',
      height: '65px',
      alignItems: 'center',
    },
    img : {
      width: '80%',
    },
    titleCol : {
        fontSize: tokens.fontSize.h3,
        lineHeight: '22px',
        fontWeight: tokens.fontWeight.semibold,
    },
    labelStyle: {
        fontSize: tokens.fontSize.small,
        lineHeight: '14px',
    },
    inputBar: {
        width: '97%',
    },
    buttonStyle: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    flexRow: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: '10px',
    },
    docRow: {
      display: 'flex',
      justifyContent: 'flex-end',
      width: '98%'
    },
    uploadButton: {
      borderRadius: tokens.radius.md,
      textShadow: 'none',
  },
  typeStyle: {
    fontWeight: tokens.fontWeight.semibold,
    fontSize: tokens.fontSize.body,
  },
  tableBorder: {
    border: `1px solid ${tokens.colors.border}`,
    marginRight: '2%',
    marginTop: '2%'
  },
});

interface IProps extends
  RouterProps,
  FormComponentProps,
  StylesProps<ReturnType<typeof styles>>{
    shipmentId?: string;
    shipmentDetails: CardData;
    documents: Document[];
    handleReloadClick: () => any;
    isArchived: boolean;
  }
  interface StateProps {
    isUploadModalVisible: boolean;
    isDeleteModalVisible: boolean;
    loading?: boolean;
    toBeDeleted?: Document;
  }
  const ContainerDocuments = (props: IProps) => {
    const [state, setState] = useGenericState<StateProps>({
      isUploadModalVisible: false,
      isDeleteModalVisible: false,
    });

    const {
      classes,
      isArchived,
      shipmentDetails,
      documents,
      handleReloadClick,
    } = props;

  const renderCol = (span, data) => {
    return <Col
      span={span}>
      {data}
    </Col>;
  };
    
  const renderDoc = () => {
    return <div>
      <Row
        style={{ marginTop: '2%' }}>
        {renderCol(6, <div
          className={classes.docStyle}>
          Documents
        </div>)}
      </Row>
      {!isArchived && <Row
        className={classes.docRow}>
        <Button
          type="primary" 
          className={classes.uploadButton}
          size="small" 
          onClick = {() => setState({ isUploadModalVisible: true })}>
          <Icon type="upload" /> Upload
        </Button>
      </Row>}
    </div>;        
  };

  const setLoader = (loading: boolean) => {
    setState({ loading });
  }
  const setUploadModalVisible = (isUploadModalVisible: boolean) => {
    setState({ isUploadModalVisible });
  }

  const handleDelete = async () => {
    const docs: Document[] = [];
    const item = state.toBeDeleted;
    documents.forEach((doc) => {
      doc !== item && docs.push(doc);
    });
    const { id } = props.match.params;
    const body = {
      documents: docs,
      shipmentId: id,
    };
    setState({ loading: true });
    const response = await updateDocuments(body);
    if (response.isSuccess) await props.handleReloadClick();
    setState({ loading: false });
  };

  const renderDeleteModal = () => {
    return <Modal okText="Submit"
    visible={state.isDeleteModalVisible}
    title="Confirm"
    onOk={() => {
      handleDelete();
      setState({ isDeleteModalVisible: false, toBeDeleted: undefined });
    }}
    onCancel={() => setState({ isDeleteModalVisible: false, toBeDeleted: undefined })}>
      Are you sure you want to delete this document? This can't be undone. </Modal>;
  };

  const columnMapping = {
    sNo: 'S.N.',
    type: 'Type',
    name: 'Attachment',
    addedAt: 'Added At',
    action: 'Action',
  };

  const getColumns = () => {
    const columns: ColumnProps<Document>[] = Object.keys(columnMapping).map((key) => ({
      key,
      dataIndex: key,
      align: 'center',
      title: columnMapping[key],
      render: (text, record, index) => {
        switch (key) {
          case 'sNo': return index + 1;
          case 'addedAt': return moment(text).format('LLLL');
          case 'name': return <a href={record.url}>{text}</a>;
          case 'action': return <Icon
            type="delete"
            onClick={() => setState({
              isDeleteModalVisible: true,
              toBeDeleted: record,
            })}
          />;
          default: return text ||'-';
        }
      }
    }));
    return columns;
  };
  const renderUploadModal = () => {
    if (state.isUploadModalVisible) {
      return <DocumentUploadModal
        visible={state.isUploadModalVisible}
        setLoader={setLoader}
        setUploadModalVisible={setUploadModalVisible}
        handleReloadClick={handleReloadClick}
        documents={documents}
        isArchived={isArchived}
      />;
    }
    return null;
  }
  const renderTable = () => {
    return <Table
      columns={getColumns()}
      rowKey={(record) => uuid()}
      className={classes.tableBorder} 
      dataSource={documents}
      pagination={false}
    />;
  };

  if (state.loading) return <Loader />;
  return <div
    style={{
      paddingLeft: 16,
    }}
  >
    {renderDoc()}
    {renderUploadModal()}
    {renderDeleteModal()}
    {renderTable()}
  </div>;
}
const ContainerDocumentsStyled = injectSheet(styles)(ContainerDocuments);
export default React.memo(withRouter(ContainerDocumentsStyled));